import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

function SvgIcon({ children, width = 24, height = 24 }) {
    return forwardRef(({ ...props }, ref) => (jsx("svg", { width: width, height: height, fill: "none", viewBox: `0 0 ${width} ${height}`, xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: children })));
}

export { SvgIcon };
